import React, {
  useState, useCallback, useMemo, ChangeEvent,
} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './DerivationPath.scss';
import { HD_DERIVATION_PATHS } from '../../../constants/wallet';

const pathRegex = /^44'\/60'\/[0-9xX]'\/[0-9xX](\/[0-9xX])?/;

const DerivationPath: React.FC<{ onConfirm: (arg: string) => void }> = ({ onConfirm }) => {
  const [path, setPath] = useState('LIVE');
  const [customPath, setCustomPath] = useState('');
  const onCustomPathChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setCustomPath(e.target.value);
    setPath('custom');
  }, []);
  const onCustomFocus = useCallback(() => {
    setPath('custom');
  }, []);
  const onPathClick = useCallback(({ target: { dataset } }) => {
    setPath(dataset.path);
  }, []);
  const onClick = useCallback(() => {
    if (path !== 'custom') {
      onConfirm(HD_DERIVATION_PATHS[path]?.value);
    } else {
      const finalPath = customPath.match(pathRegex)?.[0];
      setCustomPath(finalPath);
      onConfirm(finalPath);
    }
  }, [onConfirm, path, customPath]);

  const isValidPath = useMemo(() => {
    if (path !== 'custom') {
      return true;
    }
    return !!pathRegex.exec(customPath)?.[0] && [...customPath.matchAll(/\/x/g)].length === 1;
  }, [path, customPath]);

  return (
    <div className="web3-wc_hd-wallet__derivation-paths web3-wc_hd-wallet__common-container">
      <h4>Select a derivation path</h4>
      <div className="web3-wc_hd-wallet__list_container">
        {Object.keys(HD_DERIVATION_PATHS).map((key) => (
          <div className={clsx('web3-wc_hd-wallet__list-item', { active: path === key })} data-path={key} key={key} onClick={onPathClick}>
            {HD_DERIVATION_PATHS[key].value}
          </div>
        ))}
        <input
          value={customPath}
          onChange={onCustomPathChange}
          onFocus={onCustomFocus}
          placeholder="Custom path"
          className={clsx('web3-wc_hd-wallet__list-item custom-path', { active: path === 'custom' })}
        />
      </div>
      <button type="button" className="web3-wc_hd-wallet_warning_confirm" onClick={onClick} disabled={!isValidPath}>Confirm</button>
    </div>
  );
};

DerivationPath.propTypes = {
  onConfirm: PropTypes.func.isRequired,
};

export default DerivationPath;
